/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Guardrails_DescriptionInputs */



/**
* | output |
* | --- |
* | "Enable compliance guardrails for this model's responses." |
*
* @param {Private_Models_Form_Guardrails_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_guardrails_description = /** @type {((inputs?: Private_Models_Form_Guardrails_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Guardrails_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance-Guardrails für die Antworten dieses Modells aktivieren.")
	return /** @type {LocalizedString} */ ("Enable compliance guardrails for this model's responses.")
});